import React from 'react'
import { calculateFlexiAmount } from '@core/Areas/Quickbet/helpers/calculator'
import { FlexiDisplayStyled, AmountStyled } from './FlexiDisplay.styles'

interface FlexiDisplayProps {
  winInvestment: number
  numberCombinations: number
  isUserInputAllowed?: boolean
}

export const FlexiDisplay = ({
  winInvestment,
  numberCombinations,
  isUserInputAllowed,
}: FlexiDisplayProps): JSX.Element => {
  const calculatedFlexi = calculateFlexiAmount(winInvestment, numberCombinations)
  return (
    <FlexiDisplayStyled isActive={!!isUserInputAllowed}>
      <span>Flexi</span>{' '}
      <AmountStyled amount={calculatedFlexi}>{`${calculatedFlexi}%`}</AmountStyled>
    </FlexiDisplayStyled>
  )
}
